import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleQuestion,
  faFilePlus,
  faFileXmark,
} from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

interface IndicatorContentIconProps {
  text?: string;
  size?: number;
  className?: string;
  state: 'checkmark' | 'question' | 'no-file' | 'added-file' | undefined;
}

const getIcon = (state: IndicatorContentIconProps['state']) => {
  switch (state) {
    case 'checkmark':
      return faCircleCheck;
    case 'no-file':
      return faFileXmark;
    case 'added-file':
      return faFilePlus;

    case 'question':
    default:
      return faCircleQuestion;
  }
};

const StyledDiv = styled.div<{
  size: number;
  state: IndicatorContentIconProps['state'];
}>`
  display: grid;
  gap: ${SPACERS.tiny};
  grid-template-columns: 24px 1fr;
  word-break: break-word;
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
    svg path {
      ${({ state }) => (state === 'checkmark' ? `fill: ${COLORS.success}` : '')}
    }
  }
`;

const IndicatorContentIcon: React.FC<IndicatorContentIconProps> = ({
  text,
  state,
  size = 24,
  className,
}) => {
  return (
    <StyledDiv state={state} size={size} className={className}>
      <div className="icon">
        {state && <FontAwesomeIcon icon={getIcon(state)} />}
      </div>
      <div>{text}</div>
    </StyledDiv>
  );
};

export default IndicatorContentIcon;
